export const alphabeticSortLocation = (array: any[]) => {
  return array.sort((a, b) =>
    a.name.toLocaleLowerCase().localeCompare(b.name.toLowerCase())
  );
};
